module.exports = __webpack_public_path__ + "media/images/landing/expedia_banner-5d2132b75a21171d62b149f0232f4483.jpg";